// Ensure these IDs match the keys in backend/categoryMap.js

export const SITE_CATEGORIES = [
  {
    id: 'women',
    label: "Women's Collection",
    emoji: "👩",
    subcategories: [
      { name: "Dresses", value: "dresses", image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?q=80&w=800&auto=format&fit=crop" },
      { name: "Tops", value: "tops", image: "https://plus.unsplash.com/premium_photo-1693242804278-322d05ffcac2?q=80&w=800&auto=format&fit=crop" },
      { name: "Bottoms", value: "bottoms", image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?q=80&w=800&auto=format&fit=crop" },
      { name: "Jackets", value: "outerwear", image: "https://images.unsplash.com/photo-1544022613-e87ca75a784a?q=80&w=800&auto=format&fit=crop" },
      { name: "Bags", value: "accessories", image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?q=80&w=800&auto=format&fit=crop" },
      { name: "Jewellery", value: "jewellery", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=800&auto=format&fit=crop" }
    ]
  },
  {
    id: 'men',
    label: "Men's Collection",
    emoji: "👨",
    subcategories: [
      { name: "T-Shirts", value: "tops", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=800&auto=format&fit=crop" },
      { name: "Shirts", value: "tops", image: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?q=80&w=800&auto=format&fit=crop" },
      { name: "Bottoms", value: "bottoms", image: "https://images.unsplash.com/photo-1516826957135-700dedea698c?q=80&w=800&auto=format&fit=crop" },
      { name: "Winterwear", value: "outerwear", image: "https://images.unsplash.com/photo-1610652492500-ded49ceeb378?q=80&w=800&auto=format&fit=crop" },
      { name: "Oversized", value: "plus_size", image: "https://images.unsplash.com/photo-1584043720379-b56cd9199c94?q=80&w=800&auto=format&fit=crop" },
      { name: "Accessories", value: "accessories", image: "https://images.unsplash.com/photo-1629139033414-76f3c0eacf84?q=80&w=800&auto=format&fit=crop" }
    ]
  },
  {
    id: 'unisex',
    label: "Unisex Collection",
    emoji: "👫",
    subcategories: [
      { name: "Oversized", value: "oversized", image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?q=80&w=800&auto=format&fit=crop" },
      { name: "Hoodies", value: "hoodies", image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?q=80&w=800&auto=format&fit=crop" },
      { name: "Streetwear", value: "streetwear", image: "https://images.unsplash.com/photo-1536766820879-059fec98ec0a?q=80&w=800&auto=format&fit=crop" },
      { name: "Caps", value: "accessories", image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?q=80&w=800&auto=format&fit=crop" }
    ]
  },
  {
    id: 'trending', // Matches backend key
    label: "Trending Now ⭐",
    emoji: "🔥",
    subcategories: [
      { name: "Anime Fandom", value: "anime" },
      { name: "Trend Inspired", value: "trend" }
      // Note: 'new_arrivals' and 'best_sellers' are handled by specific boolean flags in API, not keyword search
    ]
  },
  {
    id: 'seasonal', // Matches backend key
    label: "Seasonal / Special",
    emoji: "🌤️",
    subcategories: [
      { name: "Summer Collection", value: "summer" },
      { name: "Winter Collection", value: "winter" },
      { name: "Festival Specials", value: "festival" }
    ]
  }
];